import {
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from "react-query";
import { SUPPLIERS_ENDPOINT } from "./constants";
import { useCurrentTrip } from "@/hooks";
import useFetchWithAuth from "../fetchWithAuth";
import { JobType } from ".";

const PAGE_SIZE = 10;

type Variables = {
  pageSize?: number;
  pageNum?: number;
  isInterested?: boolean;
  isSaved?: boolean;
  multipleCandidates?: boolean;
  keyword?: string;
  industries?: string;
  locations?: string;
  roles?: string;
  dateFrom?: number;
  dateTo?: number;
  isSuggested?: boolean;
  startMonths?: string;
  categories?: string;
  traits?: string;
};

export type RecentJobsQueryResult = {
  data?: Array<JobType>;
  total_count?: number;
};

export type RecentJobsFetchResult = {
  data: RecentJobsQueryResult;
  statusCode: number;
  success: boolean | string;
};

export type InfinityResult = {
  pages: Array<RecentJobsQueryResult>;
  pageParam: any[];
};
type QueryError = {};

const useRecentSearchJobsQuery = (
  params: Variables,
  queryString: string,
  options?: UseInfiniteQueryOptions<
    RecentJobsQueryResult,
    any,
    RecentJobsQueryResult,
    RecentJobsQueryResult,
    QueryKey
  >
) => {
  const { fetchWithAuth } = useFetchWithAuth();
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${SUPPLIERS_ENDPOINT}/jobs/search`;
  const cacheKey = [url, JSON.stringify(params)];

  const queryResult = useInfiniteQuery<RecentJobsQueryResult, QueryError>(
    cacheKey,
    async ({ pageParam = 1 }) => {
      const result = await fetchWithAuth<RecentJobsQueryResult>(url, {
        params: {
          tid: tid,
          ...Object.fromEntries(
            Object.entries(params).filter(
              ([key, value]) => Boolean(value) || key === "isSuggested"
            )
          ),
          page: pageParam,
          limit: params?.pageSize ?? PAGE_SIZE,
        },
        queryString,
      });
      return result;
    },
    {
      ...options,
      enabled: options?.enabled,
      getNextPageParam: (lastPage, pages) => {
        if (
          (lastPage?.total_count || 0) >=
          (params?.pageSize ?? PAGE_SIZE) * pages.length
        )
          return pages?.length + 1;
        return undefined;
      },
    }
  );
  return { ...queryResult, isLoading: queryResult.isLoading };
};
export default useRecentSearchJobsQuery;
